module.exports = __webpack_public_path__ + "images/柏纳s长图_04-1.jpg?v=c49b938b";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan2/柏纳s长图_04-1.jpg
 ** module id = 159
 ** module chunks = 1 2
 **/